<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'" >
                <wbo-single-select-edit-control [(ngModel)]="model.data.stockTransferGroupBy"
                                                [allowClearSelectionOption]="false"
                                                [formControlName]="'stockTransferGroupBy'">
                    <wbo-select-options>
                        <wbo-select-option [value]="'Source'" label="wbo.stock-in-transit-report.option.stockTransferGroupBy.source">
                        </wbo-select-option>
                        <wbo-select-option [value]="'Destination'" label="wbo.stock-in-transit-report.option.stockTransferGroupBy.destination">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-edit-control>
            </fui-row>
            <fui-row>
                <wbo-inventory-report-selection></wbo-inventory-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
